module.exports = __webpack_public_path__ + "img/ic_pinterest.76ad973f.svg";